import {css, StyleSheet} from 'aphrodite';
import React, {useState} from 'react';

import {StudyType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {ProcessTaskStatusType} from 'graphql-client/__generated/graphqlGlobalTypes';

import {MultiProcedureRunParamsTable} from './MultiProcedureRunParamsTable';
import StatusCountPane from './StatusCountPane';
import {
  getUnitOperationCountByTaskStatus,
  PLANNED,
  ProcedureRunOverview,
} from './useProcessDevelopmentStudyProgress';

export default function MultiExperimentProcessDevelopmentStudyExecutionProgress({
  overview,
  studyType,
}: {
  overview: ProcedureRunOverview;
  studyType: StudyType;
}): JSX.Element {
  // Track viewer state
  const [enabledStatusFilters, setEnabledStatusFilters] = useState(new Map());
  const setFilters = (statuses: Array<ProcessTaskStatusType>, isFilterSet: boolean): void => {
    const newEnabledStatusFilters = new Map(enabledStatusFilters);
    statuses.forEach((status) => newEnabledStatusFilters.set(status, isFilterSet));
    setEnabledStatusFilters(newEnabledStatusFilters);
  };

  // Calculate state values
  const statusCounts = getUnitOperationCountByTaskStatus(overview);

  return (
    <>
      <div className={css(styles.gridContainer)}>
        {/* ========== Body ========== */}
        <StatusCountPane
          statuses={[PLANNED]}
          statusCounts={statusCounts}
          enabledStatusFilters={enabledStatusFilters}
          setFilters={setFilters}
        />
        <StatusCountPane
          statuses={[ProcessTaskStatusType.PENDING]}
          statusCounts={statusCounts}
          enabledStatusFilters={enabledStatusFilters}
          setFilters={setFilters}
        />
        <StatusCountPane
          statuses={[ProcessTaskStatusType.IN_PROGRESS]}
          statusCounts={statusCounts}
          enabledStatusFilters={enabledStatusFilters}
          setFilters={setFilters}
        />
        <StatusCountPane
          statuses={[ProcessTaskStatusType.COMPLETED]}
          statusCounts={statusCounts}
          enabledStatusFilters={enabledStatusFilters}
          setFilters={setFilters}
        />
        <StatusCountPane
          statuses={[
            ProcessTaskStatusType.INVALID,
            ProcessTaskStatusType.SKIPPED,
            ProcessTaskStatusType.FAILED,
            ProcessTaskStatusType.CANCELLED,
          ]}
          statusCounts={statusCounts}
          enabledStatusFilters={enabledStatusFilters}
          setFilters={setFilters}
        />
      </div>
      <MultiProcedureRunParamsTable
        overview={overview}
        studyType={studyType}
        enabledStatusFilters={enabledStatusFilters}
      />
    </>
  );
}

const styles = StyleSheet.create({
  loadingDiv: {
    paddingBottom: 5,
  },
  // Layout
  gridContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(5, minmax(0, 1fr))',
    gap: 10,
    paddingBottom: 15,
  },
  // Cell Styles
  cellHeader: {
    verticalAlign: 'top',
    fontWeight: 'bold',
  },
});
